<template>
    <div class="dta-container styled-form__info styled-form__info--bg-1 text--center" v-show="isFromRego" v-html="info"></div>
</template>

<script>
    export default {
        props: {
            isFromRego: Boolean,
            info: String
        }
    };
</script>
